import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import { useTheme } from "@emotion/react";
import { useStyles } from "./styles";
import { useState } from "react";

export default function BasicAccordion({
  title,
  subtext = "",
  setExpand,
  children,
}) {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const [expanded, setExpanded] = useState(false);
  return (
    <Accordion
      className={classes.wrapper}
      expanded={expanded}
      onChange={(_, isExpanded) => {
        setExpand(isExpanded);
        setExpanded(isExpanded);
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <span className={classes.summaryContent}>
          <Typography
            className={classes.title}
            component="span"
            variant="subtitle1"
          >
            {title}
          </Typography>
          {!expanded && (
            <Typography
              className={classes.subtext}
              component="span"
              variant="subtitle1"
            >
              {subtext}
            </Typography>
          )}
        </span>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}

BasicAccordion.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  setExpand: PropTypes.func.isRequired,
};
